import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import './Teammember.css'
import { getTeamMembers } from '../api/auth/teamService';
//import { PreLoginUUID,PostLoginUUID,getToken,saveToken } from '../utils/auth';
function Meetourteam() {
    const [data, setmemberData] = useState([]);
    // const colors = ['#62d336ff', '#b20d0d', '#38bec5', '#cfcc23', '#de7d0e'];
    useEffect(() => {
        // Fetch ourteams from the backend API
        const fetchTeamMembers = async () => {
            try {
                const data = await getTeamMembers();
                setmemberData(data);
            } catch (error) {
                console.error("Error fetching team members:", error.message);
            }
        };
        fetchTeamMembers();

    }, []);

    return (
        <div>
            <Header />
            {/* Breadcrumbs */}
            <div className="breadcrumbs overlay">
                <div className="container">
                    <div className="bread-inner">
                        <div className="row">
                            <div className="col-12">
                                <h2>Meet Our Team</h2>
                                <ul className="bread-list">
                                    <li><NavLink to='/'>About</NavLink></li>
                                    <li><i className="icofont-simple-right" /></li>
                                    <li className="active">Meet Our Team</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             <section className="team section py-5" style={{ background: "#faf8f8" }}>
        <div className="container">

          <div className="section-title text-center mb-4" >
            <h2 style={{ color: "#333" }}>Meet Our Team</h2>
            <img src="img/section-img.png" alt="section-img" />
            <p style={{ color: "#333" }}>
              Behind our success is a team of highly skilled professionals who combine technology expertise with deep healthcare domain knowledge. Our team works collaboratively to deliver secure, innovative, and cost-effective IT solutions that empower hospitals, clinics, laboratories, and healthcare organizations.
            </p>
          </div>

          <div className="row">
            {data.slice(0, 5).map((member, index) => (
              <div
                key={member.id}
                className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
              >
                <div
                  className="card text-center shadow-sm h-100"
                  style={{
                    background: "#ffffff", borderLeft: "3px solid #728af2",
                    borderRadius: "12px",
                    padding: "20px"
                  }}
                >

                  <div className="mb-3">
                    <img
                      className="team-member-image"
                      src={
                        member.imageBytes
                          ? `data:image/jpeg;base64,${member.imageBytes}`
                          : "https://via.placeholder.com/100"
                      }
                      alt={member.name}
                      style={{
                        width: "180px",
                        height: "180px",
                        borderRadius: "50%",
                      }}
                    />
                  </div>

                  <p className="mb-1 fw-bold" style={{ fontSize: "1.1rem", color: "#333" }}>
                    {member.name}
                  </p>

                  <p className="mb-0" style={{ color: "#555", fontSize: "0.9rem" }}>
                    {member.designation}
                  </p>

                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
            <Footer />
        </div>
    )
}

export default Meetourteam
